export const replaceImageDimensions = (html, size = 110) => {
  if (!html || typeof html !== 'string') {
    return html;
  }

  return html.replace(/<(img)([^>]*)>/gi, (match, tagName, attributes) => {
    // Replace w=<number> and h=<number> only within the img tag attributes
    const updatedAttributes = attributes.replace(/w=\d+/g, `w=${size}`).replace(/h=\d+/g, `h=${size}`);
    return `<${tagName}${updatedAttributes}>`;
  });
};
